import {CommonModule} from '@angular/common';
import {Component, input, output} from '@angular/core';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {TranslateModule} from '@ngx-translate/core';
import {AngularSvgIconModule} from 'angular-svg-icon';

@Component({
    selector: 'app-button',
    templateUrl: './custom-button.component.html',
    styleUrls: ['./custom-button.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        AngularSvgIconModule,
        MatProgressSpinnerModule,
        TranslateModule
    ]
})
export class CustomButtonComponent
{
    public readonly type = input<'outlined' | 'transparent' | 'full'>('full');
    
    public readonly size = input<'small' | 'medium' | 'large'>('large');

    public readonly shape = input<'round' | 'square'>('round');

    public readonly theme = input<'primary' | 'secondary' | 'tertiary'>('primary');

    public readonly buttonType = input<'button' | 'submit'>('button');

    public readonly inverted = input<boolean>(false);

    public readonly icon = input<HTMLElement>();

    public readonly label = input<string>();

    public readonly fullWidth = input<boolean>(true);
    
    public readonly disabled = input<boolean>(false);
    
    public readonly textDecoration = input<boolean>(true);

    public readonly loading = input<boolean>(false);

    public readonly pressed = output();

    public buttonPressed(event: Event): void
    {
        this.pressed.emit();

        event.preventDefault();
        event.stopPropagation();
    }
}
